import React from 'react';
import { Counter } from '../counter';

type Props = Omit<React.ComponentProps<typeof Counter>, 'i18nKey'>;

const ViewCount = (props: Props) => <Counter {...props} i18nKey="view-count.label" />;

export default ViewCount;
